// extracted by mini-css-extract-plugin
module.exports = {"wrap":"header-login_wrap__D_88Z","logoWrap":"header-login_logoWrap__pxWXh","headline":"header-login_headline__Rl_9N","subHeadline":"header-login_subHeadline__71pka"};